<template>
<!-- ブラウザバック時の表示 -->
<div v-if="!katudom.bosyu_id" id="content">
	<div class="content-blk">
		<p>エラーが発生しました。トップへ戻ってください。</p>
			<div class="center">
				<router-link to="/"><button class="btn_on">検索画面へ戻る</button></router-link>
			</div>
	</div>
</div>
<div v-else id="content">
	<!-- ページ内ヘッダ -->
	<div class="center mosi_pan">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>活動選択</li>
			<li class="selected">申込理由/活動日程選択</li>
			<li>内容確認</li>
		</ul>
	</div>
	<div id="mosikomi" class="content-blk">
	<div>
		<h2>活動内容情報</h2>
		<dl class="inner">
			<dt class="detail_title">内容</dt>
			<dd class="detail_content kaigyo">{{bosyu_naiyo.naiyou}}</dd>
			<dt class="detail_title">活動場所</dt>
			<dd class="detail_content kaigyo">〒{{bosyu_naiyo.zipcode}}<br>{{bosyu_naiyo.address}}</dd>
			<dt class="detail_title">活動時間</dt>
			<dd class="detail_content">{{bosyu_naiyo.jikanFrom}}～{{bosyu_naiyo.jikanTo}}</dd>
			<dt class="detail_title">募集定員</dt>
			<dd class="detail_content" v-if="(bosyu_naiyo.jinin_code === 1)">{{bosyu_naiyo.jinin_total}}名</dd>
			<dd class="detail_content" v-if="(bosyu_naiyo.jinin_code === 2)">男性：{{bosyu_naiyo.jinin_men}}名 女性：{{bosyu_naiyo.jinin_women}}名</dd>
		</dl>
	</div>
	<div>
		<h2>申込情報選択</h2>
		<Form v-slot="{ errors }" @submit="onSubmit">
			<dl class="inner">
				<dt class="necessary detail_title">募集中ボランティア</dt>
				<dd class="hinttext">ご自身に当てはまる項目を選択してください。</dd>
				<dd class="detail_content">
					<Field as="select" name="kaiso" v-model="katudom.kaiso" :rules="isSelect">
						<option value="">---</option>
						<option value="1" v-if="bosyu_naiyo.uke_syogaku_check === 1">小学生</option>
						<option value="2" v-if="bosyu_naiyo.uke_cyugaku_check === 1">中学生</option>
						<option value="3" v-if="bosyu_naiyo.uke_koko_check === 1">高校生</option>
						<option value="4" v-if="bosyu_naiyo.uke_tansen_check === 1">短大・専門学生</option>
						<option value="5" v-if="bosyu_naiyo.uke_daigaku_check === 1">大学生</option>
						<option value="6" v-if="bosyu_naiyo.uke_syuhu_check === 1">主婦/主夫</option>
						<option value="7" v-if="bosyu_naiyo.uke_kaisya_check === 1">会社員</option>
						<option value="8" v-if="bosyu_naiyo.uke_korei_check === 1">高齢者</option>
						<option value="9" v-if="bosyu_naiyo.uke_syogai_check === 1">障がい者</option>
					</Field>
				</dd>
				<!-- ↓全階層表示 -->
				<!-- <dd class="detail_content">
					<Field as="select" name="kaiso" v-model="katudom.kaiso" :rules="isSelect">
						<option value="">---</option>
						<option value="1">小学生</option>
						<option value="2">中学生</option>
						<option value="3">高校生</option>
						<option value="4">短大・専門学生</option>
						<option value="5">大学生</option>
						<option value="6">主婦/主夫</option>
						<option value="7">会社員</option>
						<option value="8">高齢者</option>
						<option value="9">障がい者</option>
					</Field>
				</dd> -->
				<dd class="error">{{ errors.kaiso }}</dd>
			</dl>
			<dl class="inner">
				<dt class="necessary detail_title">申込理由</dt>
				<dd class="hinttext">（複数選択可）</dd>
				<!-- computer design -->
				<dd class="detail_content list_nittei">
					<div><input type="checkbox" name="tika" true-value="1" false-value="0" v-model="katudom.reason1" id="tika" /><label for="tika">居住地に近い</label></div>
					<div><input type="checkbox" name="miryoku" true-value="1" false-value="0" v-model="katudom.reason2" id="miryoku" /><label for="miryoku">活動内容が魅力的</label></div>
					<div><input type="checkbox" name="kotu" true-value="1" false-value="0" v-model="katudom.reason3" id="kotu" /><label for="kotu">通勤・通学等交通の便がよい</label></div>
					<div><input type="checkbox" name="kikan" true-value="1" false-value="0" v-model="katudom.reason4" id="kikan" /><label for="kikan">活動期間</label></div>
					<div><input type="checkbox" name="yujin" true-value="1" false-value="0" v-model="katudom.reason5" id="yujin" /><label for="yujin">友人・知人が行くので</label></div>
					<div><input type="checkbox" name="sonota" true-value="1" false-value="0" v-model="katudom.reason6" id="sonota" /><label for="sonota">その他</label>
					<div v-if="katudom.reason6 === '1'">
						<textarea v-model="katudom.sonota"></textarea>
						<Field type="text" name="sonotar" v-model="katudom.sonota" :rules="isReason" class="hideObject" />
					<!-- <p class="error">{{ errors.sonotar }}</p> -->
					</div>
					</div>
				</dd>
				<!-- responsive design -->
				<dd class="detail_content d_list_nittei">
					<div class="d_riyu"><input type="checkbox" name="tika" true-value="1" false-value="0" v-model="katudom.reason1" id="tika" /><label for="tika">居住地に近い</label></div>
					<div class="d_riyu"><input type="checkbox" name="miryoku" true-value="1" false-value="0" v-model="katudom.reason2" id="miryoku" /><label for="miryoku">活動内容が魅力的</label></div>
					<div class="d_riyu"><input type="checkbox" name="kotu" true-value="1" false-value="0" v-model="katudom.reason3" id="kotu" /><label for="kotu">通勤・通学等交通の便がよい</label></div>
					<div class="d_riyu"><input type="checkbox" name="kikan" true-value="1" false-value="0" v-model="katudom.reason4" id="kikan" /><label for="kikan">活動期間</label></div>
					<div class="d_riyu"><input type="checkbox" name="yujin" true-value="1" false-value="0" v-model="katudom.reason5" id="yujin" /><label for="yujin">友人・知人が行くので</label></div>
					<div class="d_riyu"><input type="checkbox" name="sonota" true-value="1" false-value="0" v-model="katudom.reason6" id="sonota" /><label for="sonota">その他</label>
					<div v-if="katudom.reason6 === '1'" class="d_riyu">
						<textarea v-model="katudom.sonota"></textarea>
						<Field type="text" name="sonotar" v-model="katudom.sonota" :rules="isReason" class="hideObject" />
					<!-- <p class="error">{{ errors.sonotar }}</p> -->
					</div>
					</div>
				</dd>
				<!-- <dd class="error">{{ error_riyu }}</dd> -->
				<dd v-if="error_riyu && ((katudom.reason1 !== '0') || (katudom.reason2 !== '0') || (katudom.reason3 !== '0') || (katudom.reason4 !== '0') || (katudom.reason5 !== '0') || (katudom.reason6 !== '0'))" class="error"></dd>
				<dd v-else-if="error_riyu" class="error">{{ error_riyu }}</dd>
				<dd class="error">{{ errors.sonotar }}</dd>
			</dl>
			<dl class="inner">
				<dt class="necessary detail_title">日程一覧</dt>
				<!-- <dd class="hinttext">※活動日1ヶ月～5日前から申込可能となります。</dd> -->
				<dd class="hinttext">※活動日1ヶ月～3日前から申込可能となります。</dd>
				<dd class="warn_red hinttext">※残数が0の場合でも申込できますが、青森市ボランティアセンターに確認の上、申込してください。</dd>
				<dd class="detail_content">
					<!-- PCデザイン -->
					<table class="list list_nittei">
						<tr>
							<th></th>
							<th>日付</th>
							<th>残数</th>
						</tr>
						<template v-for="kn in k_nittei" :key="kn.katudo_date">
						<!-- <tr v-if="(kn.hyoji_code === 1)"> -->
						<!-- 1ヶ月～3日前表示設定 -->
						<tr v-if="(kn.hyoji_code === 1) && ((new Date(kn.katudo_date)) > (DAY3)) && ((MONTH1) > (new Date(kn.katudo_date)))">
							<td>
								<!-- 申込不可の場合 -->
								<!-- 申込停止 -->
								<input v-if="kn.jyokyo_code !== 1" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date" disabled>
								<!-- 残数0だが申込可 -->
								<!-- 男性 -->
								<input v-else-if="(login.sex === 2) && (kn.zan_men === 0) && (kn.jinin_men !== 0)" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<input v-else-if="(login.sex === 2) && (kn.jinin_men === 0) && (kn.jinin_women !== 0)" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<!-- 女性 -->
								<input v-else-if="(login.sex === 1) && (kn.zan_women === 0) && (kn.jinin_women !== 0)" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<input v-else-if="(login.sex === 1) && (kn.jinin_men !== 0) && (kn.jinin_women === 0)" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<!-- 性別問わず -->
								<input v-else-if="(kn.zan_total === 0) && (kn.jinin_total !== 0)" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<!-- 例外？ -->
								<input v-else-if="(kn.zan_men === 0) && (kn.zan_women === 0) && (kn.zan_total === 0)" class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<!-- 申込可能な場合 -->
								<input v-else class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<label v-if="kn.jyokyo_code !== 1" :for="kn.katudo_date">申込停止</label>
								<label v-else :for="kn.katudo_date">選択</label>
							</td>
							<td>
								{{format(new Date(kn.katudo_date),'yyyy/MM/dd(E)',{locale: ja})}}
							</td>
							<!-- 性別問わずの場合 -->
							<td v-if="(kn.jinin_men === 0) && (kn.jinin_women === 0)">
								<!-- 残数なし -->
								<!-- 申込不可のアイコン -->
								<!-- 残数0申込可 -->
								<fa v-if="kn.zan_total <= 0" icon="times" class="icon mosikomi_no" />
								<!-- 残数１ -->
								<fa v-else-if="kn.zan_total === 1" icon="exclamation-triangle" class="icon mosikomi_warn" />
								<!-- 残数2以上 -->
								<fa v-else :icon="['far','circle']" class="icon mosikomi_ok" />
								<span class="zan_span" v-if="kn.zan_total < 0">0</span>
								<span class="zan_span" v-else>{{ kn.zan_total }}</span>
							</td>
							<!-- 男女別募集の場合 -->
							<td v-else>
								<!-- 男性 -->
								<!-- 残数0 -->
								<fa v-if="kn.zan_men <= 0" icon="times" class="icon mosikomi_no" />
								<!-- 残数１ -->
								<fa v-else-if="kn.zan_men === 1" icon="exclamation-triangle" class="icon mosikomi_warn" />
								<!-- 残数2以上 -->
								<fa v-else :icon="['far','circle']" class="icon mosikomi_ok" />
								男性：
								<span v-if="kn.zan_men < 0">0</span>
								<span v-else>{{kn.zan_men}}</span>
								&emsp;
								<!-- 女性 -->
								<!-- 残数0 -->
								<fa v-if="kn.zan_women <= 0" icon="times" class="icon mosikomi_no" />
								<!-- 残数１の時に少なめ -->
								<fa v-else-if="(kn.zan_women === 1)" icon="exclamation-triangle" class="icon mosikomi_warn" />
								<!-- 残数2以上 -->
								<fa v-else :icon="['far','circle']" class="icon mosikomi_ok" />
								女性：
								<span v-if="kn.zan_women < 0">0</span>
								<span v-else>{{kn.zan_women}}</span>
							</td>
						</tr>
						</template>
					</table>
					<!-- レスポンシブデザイン -->
					<div class="d_list_nittei">
						<div v-for="kn in k_nittei" :key="kn.katudo_date">
							<!-- 1ヶ月～3日前表示設定 -->
							<div v-if="(kn.hyoji_code === 1) && ((new Date(kn.katudo_date)) > (DAY3)) && ((MONTH1) > (new Date(kn.katudo_date)))">
								<input class="katudo_check" type="checkbox" v-model="katudom.nittei" :value="kn.katudo_date" :id="kn.katudo_date">
								<label :for="kn.katudo_date" class="d_list_box">
									<div class="d_list_select">
										<fa v-if="kn.jyokyo_code !== 1" icon="minus" class="icon" />
										<fa v-else icon="check" class="icon" />
									</div>
									<div>
										<p class="nittei_date">{{format(new Date(kn.katudo_date),'yyyy/MM/dd(E)',{locale: ja})}}</p>
										<p>【残数】
										<!-- 性別問わずの場合 -->
										<span v-if="(kn.jinin_men === 0) && (kn.jinin_women === 0)">
											<!-- 残数なし -->
											<fa v-if="kn.zan_total <= 0" icon="times" class="icon mosikomi_no" />
											<!-- 残数１ -->
											<fa v-else-if="kn.zan_total === 1" icon="exclamation-triangle" class="icon mosikomi_warn" />
											<!-- 残数２以上 -->
											<fa v-else :icon="['far','circle']" class="icon mosikomi_ok" />
											<span class="zan_span" v-if="kn.zan_total < 0">0</span>
											<span class="zan_span" v-else>{{ kn.zan_total }}</span>
										</span>
										<!-- 男女別募集の場合 -->
										<span v-else>
											<!-- 男性 -->
											<!-- 残数なし -->
											<fa v-if="kn.zan_men <= 0" icon="times" class="icon mosikomi_no" />
											<!-- 残数１ -->
											<fa v-else-if="kn.zan_men === 1" icon="exclamation-triangle" class="icon mosikomi_warn" />
											<!-- 残数2以上 -->
											<fa v-else :icon="['far','circle']" class="icon mosikomi_ok" />
											男性：
											<span v-if="kn.zan_men < 0">0</span>
											<span v-else>{{kn.zan_men}}</span>
											&emsp;
											<!-- 女性 -->
											<!-- 残数0 -->
											<fa v-if="kn.zan_women <= 0" icon="times" class="icon mosikomi_no" />
											<!-- 残数１ -->
											<fa v-else-if="kn.zan_women === 1" icon="exclamation-triangle" class="icon mosikomi_warn" />
											<!-- 残数2以上 -->
											<fa v-else :icon="['far','circle']" class="icon mosikomi_ok" />
											女性：
											<span v-if="kn.zan_women < 0">0</span>
											<span v-else>{{kn.zan_women}}</span>
										</span></p>
									</div>
								</label>
							</div>
						</div>
					</div>
				</dd>
				<!-- <dd v-if="(Object.keys(errors).length && (katudom.nittei))" class="error">活動日程を選択してください。</dd> -->
				<dd v-if="error_nittei && (katudom.nittei.length !== 0)" class="error"></dd>
				<dd v-else-if="error_nittei" class="error">{{ error_nittei }}</dd>
			</dl>
			<div class="button_rev justifycont-c buttons">
				<button type="submit" @click="submitCheck" class="btn_on order2">申込確認</button>
				<router-link to="/" class="order1"><button class="btn_cancel">検索へ戻る</button></router-link>
			</div>
			<p v-if="Object.keys(errors).length || (error_nittei && (katudom.nittei.length === 0)) || (error_riyu && ((this.katudom.reason1 === '0') && (this.katudom.reason2 === '0') && (this.katudom.reason3 === '0') && (this.katudom.reason4 === '0') && (this.katudom.reason5 === '0') && (this.katudom.reason6 === '0')))" class="error" style="text-align: center;">未入力もしくはエラー項目があります。ご確認ください。</p>
		</Form>
	</div>
	</div>
</div>
</template>

<script>
import { inject } from 'vue';
import { Field, Form } from 'vee-validate';
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
import router from '../router';
import axios from 'axios';

export default {
	name: 'KatsudoMosikomi',
	components: {
		Field,
		Form,
	},
	setup() {
		const { katudom, resetsonota } = inject('kmosikomi');
		const { login } = inject('loginstate');
		return {
			katudom,
			resetsonota,
			format,
			ja,
			login,
		};
	},
	props: {
		value: String
	},
	data() {
		// 3日前まで申込可の設定
		const DAY3 = new Date();
		DAY3.setDate(DAY3.getDate() + 2);
		// 1ヶ月前から申込可
		const MONTH1 = new Date();
		MONTH1.setMonth(MONTH1.getMonth() + 1);
		return {
			error_riyu: "",
			error_nittei: "",
			k_nittei: [],
			bosyu_naiyo: [],
			DAY3,
			MONTH1,
		};
	},
	async created() {
		this.katudom.bosyu_id = this.value;
		// 活動日程取得
		let res = await axios.get('/api/bosyu_data/nittei?id='+ this.katudom.bosyu_id)
		// console.log(res.data)
		this.k_nittei = res.data

		// 募集要項情報
		let res2 = await axios.get('/api/bosyu_data/info?id='+ this.katudom.bosyu_id)
		// console.log(res2.data)
		this.bosyu_naiyo = res2.data

		// 募集要項加工
		// 時間
		this.bosyu_naiyo.jikanFrom = this.bosyu_naiyo.jikan_from.slice(0,5)
		this.bosyu_naiyo.jikanTo = this.bosyu_naiyo.jikan_to.slice(0,5)
	},
	methods: {
		submitCheck(){
			if ((this.katudom.reason1 === "0") && (this.katudom.reason2 === "0") && (this.katudom.reason3 === "0") && (this.katudom.reason4 === "0") && (this.katudom.reason5 === "0") && (this.katudom.reason6 === "0") && (this.katudom.nittei.length === 0)) {
				this.error_riyu = "申込理由を選択してください。"
				this.error_nittei = "活動日程を選択してください。"
			} else if ((this.katudom.reason1 === "0") && (this.katudom.reason2 === "0") && (this.katudom.reason3 === "0") && (this.katudom.reason4 === "0") && (this.katudom.reason5 === "0") && (this.katudom.reason6 === "0")) {
				this.error_riyu = "申込理由を選択してください。"
				this.error_nittei = ""
			} else if (this.katudom.nittei.length === 0) {
				this.error_riyu = ""
				this.error_nittei = "活動日程を選択してください。"
			} else {
				this.error_riyu = ""
				this.error_nittei = ""
			}
		},
		onSubmit() {
			if ((this.katudom.reason1 === "0") && (this.katudom.reason2 === "0") && (this.katudom.reason3 === "0") && (this.katudom.reason4 === "0") && (this.katudom.reason5 === "0") && (this.katudom.reason6 === "0") && (this.katudom.nittei.length === 0)) {
				this.error_riyu = "申込理由を選択してください。"
				this.error_nittei = "活動日程を選択してください。"
			} else if ((this.katudom.reason1 === "0") && (this.katudom.reason2 === "0") && (this.katudom.reason3 === "0") && (this.katudom.reason4 === "0") && (this.katudom.reason5 === "0") && (this.katudom.reason6 === "0")) {
				this.error_riyu = "申込理由を選択してください。"
				this.error_nittei = ""
			} else if (this.katudom.nittei.length === 0) {
				this.error_riyu = ""
				this.error_nittei = "活動日程を選択してください。"
			} else {
				this.error_riyu = ""
				this.error_nittei = ""
				this.resetsonota();
				router.push({ path: '/katudo-mosikomi/confirm'});
			}
		},
		// 選択必須のバリデーション
		isSelect(value) {
			return value ? true : '必須項目です';
		},
		// 200文字以内のバリデーション
		isReason(value) {
			if (value.length > 200) {
				return '200文字以内で入力してください。';
			}
			return true;
		},
	},
}
</script>

<style scoped>
.zan_span {
	margin-left: 0.5em;
}
</style>
